import { useState } from "react";
import { Link } from "react-router-dom";

// T53: full, readable category crumbs; only the final (product) crumb truncates, with the full name on hover.
// Phone (<640px): Home / … / parent / current, the "…" button reveals the middle crumbs.
const Sep = () => <span aria-hidden="true" className="text-slate-300">/</span>;

export function Breadcrumbs({ items, current, testid = "breadcrumbs", className = "mb-5" }) {
  const [open, setOpen] = useState(false);
  const all = [{ to: "/", label: "Home" }, ...items];
  const collapse = all.length > 2 && !open;
  const mid = (i) => i > 0 && i < all.length - 1;
  return (
    <nav aria-label="Breadcrumb" className={`text-sm text-slate-500 ${className}`} data-testid={testid}>
      <ol className="flex flex-wrap items-center gap-x-1.5 gap-y-1">
        {all.map((c, i) => (
          <li key={c.to + i} className={`items-center gap-1.5 ${collapse && mid(i) ? "hidden sm:flex" : "flex"}`}>
            {i > 0 && <Sep />}
            {i === all.length - 1 && !current ? <span className="text-slate-700" aria-current="page">{c.label}</span>
              : <Link to={c.to} className="hover:text-[var(--brand-primary)] hover:underline" data-testid={`${testid}-link-${i}`}>{c.label}</Link>}
            {i === 0 && collapse && (
              <span className="flex items-center gap-1.5 sm:hidden"><Sep />
                <button type="button" onClick={() => setOpen(true)} aria-label="Show the full category path" data-testid={`${testid}-expand`}
                  className="-my-2 inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-md px-2 font-semibold hover:bg-slate-100">…</button>
              </span>
            )}
          </li>
        ))}
        {current && (
          <li className="flex min-w-0 items-center gap-1.5"><Sep />
            <span className="block max-w-[12rem] truncate text-slate-700 sm:max-w-[26rem]" title={current} aria-current="page" data-testid={`${testid}-current`}>{current}</span>
          </li>
        )}
      </ol>
    </nav>
  );
}
